import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// Use "proposal-filter-6" api for proposalFilterOther

export const getSchema = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/proposal-filter-6`
  return doGet(url)
}

export const saveProposalFilterOther = (request) => {
  const url = `${API_ROOT}/review/proposal-filter-6`
  return doPost(url, request)
}
